import React from 'react';
import { Empty } from 'antd';
import cn from 'classnames';
import SetupDesks from '../../../../presenters/SetupDesks';
import { useDesksConfigs } from '../../services/desksConfigs';
import { useFormWatch } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import styles from './index.module.scss';

const Body = () => {
  const configsCollection = useDesksConfigs();

  const configId = useFormWatch({ name: fieldNames.main.configId });

  const immutabilityChecks = configsCollection.getImmutabilityChecks(configId);

  return (
    <div className={cn(styles.root, { [styles.content]: Boolean(configId) })}>
      {configId ? (
        <SetupDesks immutabilityChecks={immutabilityChecks} />
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Выберите кофигурацию"
        />
      )}
    </div>
  );
};

export default Body;
